<!-- eslint-disable vue/no-unused-properties -->
<script setup lang="ts">
import { InputOptions, BaseInputField } from '@/interfaces/InputFields';
import { unref } from 'vue';

const model = defineModel();
const props = defineProps<
  BaseInputField & {
    modelValue?: any;
    autofocus?: boolean;
    disabled?: boolean;
    valid: boolean;
    size?: 'small' | 'medium' | 'large';
  }
>();

if (!model.value && props.options) {
  const options = unref(props.options) as InputOptions[];
  const selectedOption = options.find((opt) => opt.selected);
  if (selectedOption) {
    model.value = selectedOption.value;
  }
}
</script>

<template>
  <select
    :id="name"
    v-model="model"
    :name="name"
    :disabled="disabled"
    :required="required"
    :autofocus="autofocus"
    class="Field Field--select peer"
    :class="[
      `Field--${size}`,
      {
        'Field--invalid': !valid,
      },
    ]"
  >
    <option
      v-for="(option, index) in options as InputOptions[]"
      :key="index"
      :selected="option.value === model"
      :value="option.value"
    >
      {{ option.label }}
    </option>
  </select>
</template>
